<label>{{ label }}</label>
<ng-select
  [items]="companies$ | async"
  bindValue="id"
  [(ngModel)]="value"
  (change)="onChange()"
  class="filter-select"
  [multiple]="options?.multi"
  [typeahead]="companyInput$"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
      >×</span
    >
    {{ item.business_name ?? businessName }}
  </ng-template>
  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
  >
    <h6>{{ item.business_name }}</h6>
  </ng-template>
</ng-select>
